// products
const socketImage = require("../../../assets/images/products/socket.jpg");
const lightsImage = require("../../../assets/images/products/lights.jpg");
const cabinetImage = require("../../../assets/images/products/cabinet.jpg");
const flooringImage = require("../../../assets/images/products/flooring.jpg");
const hvacImage = require("../../../assets/images/products/hvac.jpg");
const laminarImage = require("../../../assets/images/products/laminar.jpg");
const lightingImage = require("../../../assets/images/products/lighting.jpg");
const supplyUnitImage = require("../../../assets/images/products/supply_unit.jpg");
const wallSurfaceImage = require("../../../assets/images/products/wall_surface.jpg");
const doorImage = require("../../../assets/images/products/door.jpg");
const controlPanelImage = require("../../../assets/images/products/control_panel.jpg");

// subproducts

const ukSocketImage = require("../../../assets/images/products/subproducts/uk_socket.png");
const dinSocketImage = require("../../../assets/images/products/subproducts/din_socket.png");
const universalSocketImage = require("../../../assets/images/products/subproducts/universal_socket.png");
const dinStandardOutletImage = require("../../../assets/images/products/subproducts/din_standard_outlet.png");
const britishStandardOutletImage = require("../../../assets/images/products/subproducts/british_standard_outlet.png");
const slidingDoorImage = require("../../../assets/images/products/subproducts/sliding_door.png");
const slidingDoorAutoImage = require("../../../assets/images/products/subproducts/sliding_door_auto.png");
const slidingDoorManualImage = require("../../../assets/images/products/subproducts/sliding_door_manual.png");
const swingDoorImage = require("../../../assets/images/products/subproducts/swing_door.png");
const swingDoorDoubleLeafImage = require("../../../assets/images/products/subproducts/swing_door_double_leaf.png");
const swingDoorDoubleLeafImage1 = require("../../../assets/images/products/subproducts/swing_door_double_leaf1.png");
const otLight1Image = require("../../../assets/images/products/subproducts/ot_light1.png");
const otLight2Image = require("../../../assets/images/products/subproducts/ot_light2.png");
const otLight3Image = require("../../../assets/images/products/subproducts/ot_light3.png");
const otLight4Image = require("../../../assets/images/products/subproducts/ot_light4.png");
const cabinet1Image = require("../../../assets/images/products/subproducts/cabinet1.png");
const cabinet2Image = require("../../../assets/images/products/subproducts/cabinet2.png");
const cabinet3Image = require("../../../assets/images/products/subproducts/cabinet3.png");
const cabinet4Image = require("../../../assets/images/products/subproducts/cabinet4.png");
const xrayViewerImage = require("../../../assets/images/products/subproducts/xray_viewer.png");
const writingTableImage = require("../../../assets/images/products/subproducts/writing_table.png");
const ambientLightsImage = require("../../../assets/images/products/subproducts/ambient_lights.png");
const flooring1Image = require("../../../assets/images/products/subproducts/flooring1.png");
const flooring2Image = require("../../../assets/images/products/subproducts/flooring2.png");
const flooring3Image = require("../../../assets/images/products/subproducts/flooring3.png");
const flooring4Image = require("../../../assets/images/products/subproducts/flooring4.png");
const flooring5Image = require("../../../assets/images/products/subproducts/flooring5.png");
const hvacGrillImage = require("../../../assets/images/products/subproducts/hvac_grill.png");
const surgeonPendantImage = require("../../../assets/images/products/subproducts/surgeon_pendant.png");
const anesthesiaPendantImage = require("../../../assets/images/products/subproducts/anesthesia_pendant.png");
const endoscopyPendantImage = require("../../../assets/images/products/subproducts/endoscopy_pendant.png");
const laminarFlowSystemImage = require("../../../assets/images/products/subproducts/laminar_flow_system.png");
const laminarFlowSystemImage1 = require("../../../assets/images/products/subproducts/laminar_flow_system1.png");
const controlPanel1 = require("../../../assets/images/products/subproducts/control_panel1.png");
const controlPanel2 = require("../../../assets/images/products/subproducts/control_panel2.png");
const controlPanel3 = require("../../../assets/images/products/subproducts/control_panel3.png");
const controlPanel4 = require("../../../assets/images/products/subproducts/control_panel4.png");
const wallStructure1Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4116.webp");
const wallStructure2Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4117.webp");
const wallStructure3Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4118.webp");
const wallStructure4Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4119.webp");
const wallStructure5Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4120.webp");
const wallStructure6Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4121.webp");
const wallStructure7Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4122.webp");
const wallStructure8Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4123.webp");
const wallStructure9Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4124.webp");
const wallStructure10Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4125.webp");
const wallStructure11Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4126.webp");
const wallStructure12Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4127.webp");
const wallStructure13Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4128.webp");
const wallStructure14Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4129.webp");
const wallStructure15Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4130.webp");
const wallStructure16Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4131.webp");
const wallStructure17Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4132.webp");
const wallStructure18Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4133.webp");
const wallStructure19Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4134.webp");
const wallStructure20Image = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4135.webp");

const ProductsData = [
  {
    id: "1",
    title: "Cabinet Solution & Wall Accessories",
    key: "Cabinet-Solution-&-Wall-Accessories",
    image: cabinetImage,
    products: [
      {
        title: "Cabinets",
        description: [
          "Built-in storage cabinets provide a smooth exterior surface, keeping your OR tidy and organized. Separate cabinets for endoscopy supplies, anesthesia or general OR storage are available. Options include glass front and drawers.",
        ],
        imagesData: [
          {
            image: cabinet1Image,
            title: "Cabinet 1",
          },
          {
            image: cabinet2Image,
            title: "Cabinet 2",
          },
          {
            image: cabinet3Image,
            title: "Cabinet 3",
          },
          {
            image: cabinet4Image,
            title: "Cabinet 4",
          },
        ],
      },
      {
        title: "X ray viewer",
        description: [
          "The LED X-ray viewer with integrated aperture control helps the surgical team focus on either the entire area or a specific area that may be of importance.",
        ],
        imagesData: [
          {
            image: xrayViewerImage,
            title: "X Ray Viewer",
          },
        ],
      },
      {
        title: "Writing Desk",
        description: [
          "A folding desk with its own light will help the shopkeeper to continue his work calmly and discreetly.",
        ],
        imagesData: [
          {
            image: writingTableImage,
            title: "Writing Table",
          },
        ],
      },
    ],
  },

  {
    id: "2",
    title: "Ambient Lighting",
    key: "Ambient-Lighting",
    image: lightingImage,
    products: [
      {
        title: "Ambient Lighting",
        description: [
          "The OR is equipped with LED lights integrated into the ceiling. They are controlled via the control panel and are dimmable.",
        ],
        imagesData: [
          {
            image: ambientLightsImage,
            title: "Ambient Lights",
          },
        ],
      },
    ],
  },

  {
    id: "3",
    title: "Flooring",
    key: "Flooring",
    image: flooringImage,
    products: [
      {
        title: "Flooring",
        description: [
          "For floor treatment, Herzmann offers a standard anti-bacteriological vinyl which, however, in the Herzmann system is provided with a special design of the baseboards, which not only offers an absolutely hygienic surface but also creates ingenious aesthetics.",
        ],
        imagesData: [
          {
            image: flooring1Image,
            title: "Flooring",
          },
          {
            image: flooring2Image,
            title: "Flooring",
          },
          {
            image: flooring3Image,
            title: "Flooring",
          },
          {
            image: flooring4Image,
            title: "Flooring",
          },
          {
            image: flooring5Image,
            title: "Flooring",
          },
        ],
      },
    ],
  },

  {
    id: "4",
    title: "HVAC",
    key: "HVAC",
    image: hvacImage,
    products: [
      {
        title: "HVAC",
        description: [
          "We only supply grills and visible components of the air conditioners as these need to be integrated into the wall structure. The HVAC suppliers plug into our outlets. These include return air grills, pressure dampers, and intake grills as suggested by the HVAC suppliers.",
          " Our control panel can operate the air conditioner in cases where the communication protocols are compatible.",
        ],
        imagesData: [
          {
            image: hvacGrillImage,
            title: "HVAC Grill",
          },
        ],
      },
    ],
  },

  {
    id: "5",
    title: "Ceiling Supply Unit",
    key: "Ceiling-Supply-Unit",
    image: supplyUnitImage,
    products: [
      {
        title: "Ceiling Supply Unit",
        description: [
          "To keep the OT environment cluster-free, well-organized and hygienic, our tags are an essential accessory. These systems are highly configurable to meet different needs. However, standard configurations are also based on extensive experience and facilitate decision-making.",
          "Special pendants for surgeons with general or endoscopic equipment and for anesthesia are available. Once selected during the design phase, the systems are seamlessly and cleanly integrated.",
        ],
        imagesData: [
          {
            image: surgeonPendantImage,
            title: "Surgeon’s Pendant",
          },
          {
            image: anesthesiaPendantImage,
            title: "Anesthesia Pendant",
          },
          {
            image: endoscopyPendantImage,
            title: "Endoscopy Pendant",
          },
        ],
      },
    ],
  },

  {
    id: "6",
    title: "Structure & Wall Surface",
    key: "Structure-&-Wall-Surface",
    image: wallSurfaceImage,
    products: [
      {
        title: "Strukture und Wandoberflache",
        description: [
          "Dank unserer patentierten Wandstruktur können unsere Wandpaneele schnell und genau montiert werden. Dieses von Herzmann entworfene, entwickelte und hergestellte System bildet den Kern unserer Lösung.",
          " Diese Struktur kann dann mit Stahl-, Glas- oder Edelstahlplatten versehen werden. Diese Paneele entsprechen unseren hohen Standards, um Wärmeverluste und Schalldämpfung zu vermeiden.",
          " Unser Designteam arbeitet eng mit den Architekten und Krankenhausbesitzern zusammen, um das optimale Design und Finish zu erzielen.",
        ],
        imagesData: [
          {
            id: 1,
            image: wallStructure1Image,
            title: "title1",
          },
          {
            id: 2,
            image: wallStructure2Image,
            title: "title2",
          },
          {
            id: 3,
            image: wallStructure3Image,
            title: "title3",
          },
          {
            id: 4,
            image: wallStructure4Image,
            title: "title3",
          },
          {
            id: 5,
            image: wallStructure5Image,
            title: "title3",
          },
          {
            id: 6,
            image: wallStructure6Image,
            title: "title3",
          },
          {
            id: 7,
            image: wallStructure7Image,
            title: "title3",
          },
          {
            id: 8,
            image: wallStructure8Image,
            title: "title3",
          },
          {
            id: 9,
            image: wallStructure9Image,
            title: "title3",
          },
          {
            id: 10,
            image: wallStructure10Image,
            title: "title3",
          },
          {
            id: 11,
            image: wallStructure11Image,
            title: "title3",
          },
          {
            id: 12,
            image: wallStructure12Image,
            title: "title3",
          },
          {
            id: 13,
            image: wallStructure13Image,
            title: "title3",
          },
          {
            id: 14,
            image: wallStructure14Image,
            title: "title3",
          },
          {
            id: 15,
            image: wallStructure15Image,
            title: "title3",
          },
          {
            id: 16,
            image: wallStructure16Image,
            title: "title3",
          },
          {
            id: 17,
            image: wallStructure17Image,
            title: "title3",
          },
          {
            id: 18,
            image: wallStructure18Image,
            title: "title3",
          },
          {
            id: 19,
            image: wallStructure19Image,
            title: "title3",
          },
          {
            id: 20,
            image: wallStructure20Image,
            title: "title3",
          },
        ],
      },
    ],
  },

  {
    id: "7",
    title: "Laminar Flow System",
    key: "Laminar-Flow-System",
    image: laminarImage,
    products: [
      {
        title: "Laminar Flow System",
        description: [
          "The laminar flow system is connected to the air conditioning system via a standard duct connection. The air conditioning is supplied by others. Optionally, our control panel can connect to and control the HVAC should the air conditioner use common protocols.",
        ],
        imagesData: [
          {
            image: laminarFlowSystemImage,
            title: "Laminar Flow System",
          },
          {
            image: laminarFlowSystemImage1,
            title: "Laminar Flow System",
          },
        ],
      },
    ],
  },

  {
    id: "8",
    title: "Control Panel",
    key: "Control-Panel",
    image: controlPanelImage,
    // description:
    // "The Home Screen's primary purpose is to display the analogue sensor, gas sensor, time, and date values. controls the anesthesia timer, operation timer, digital output buttons. The provided is marked as follows. • The home screen will appear when the home button is clicked. • The time and date will correspond to those of the current location.  • During the period of the operation and anesthesia, the Operation and Anesthetic Timer is used. The BUSY digital output button can also be used to manage operation time. • Analog sensors showed the value for the operating room's temperature, pressure, air flow, and humidity, allowing us to adjust the operating room's condition.  • Gas sensors are used to detect various gases, display gas concentrations, and enable us to regulate gas concentrations in emergency situations. • Different sensors and lights are controlled by digital output buttons.",
    description: [
      "The Home Screen's primary purpose is to display the analogue sensor, gas sensor, time, and date values. controls the anesthesia timer, operation timer, digital output buttons. The provided is marked as follows. ",
      "The home screen will appear when the home button is clicked. ",
      "The time and date will correspond to those of the current location. ",
      " During the period of the operation and anesthesia, the Operation and Anesthetic Timer is used. The BUSY digital output button can also be used to manage operation time. ",
      " Analog sensors showed the value for the operating room's temperature, pressure, air flow, and humidity, allowing us to adjust the operating room's condition.",
      "Gas sensors are used to detect various gases, display gas concentrations, and enable us to regulate gas concentrations in emergency situations. ",
      "Different sensors and lights are controlled by digital output buttons.",
    ],
    technicalInfo: [
      "Technical info1",
      "Technical info2",
      "Technical info3",
      "Technical info4",
    ],

    imagesData: [
      {
        image: controlPanel1,
        imageTitle: "Home Screen",
        imageDescription:
          "The Home Screen's primary purpose is to display the analogue sensor, gas sensor, time, and date values. controls the anesthesia timer, operation timer, digital output buttons. The provided is marked as follows.",
        imageDescriptionList: [
          "The home screen will appear when the home button is clicked.",
          "The time and date will correspond to those of the current location.",
          "During the period of the operation and anesthesia, the Operation and Anesthetic Timer is used. The BUSY digital output button can also be used to manage operation time.",
          "Different sensors and lights are controlled by digital output buttons",
        ],
      },
      {
        image: controlPanel2,
        imageTitle: "Analog Sensors Screen",
        imageDescription:
          "The values of the analogue sensors (Temperature, Humidity, Pressure, and Air Flow) are displayed on this screen. We can choose the threshold values for the sensors, as well as regulate the fan and AC temperature. The given screen will be displayed when the analogue sensors button is pressed",
        imageDescriptionList: [
          "Four analog sensor Temperature, Humidity, Pressure and Air Flow value can be also displayed here. We pressed the Confirm Button to select the threshold for the sensor that which value the alert can be occur.",
          "In the operating room, there is a fan button and control that turns the fan on and off and regulates its speed",
        ],
      },
      {
        image: controlPanel3,
        imageTitle: "Light Screen",
        imageDescription:
          "The light screen can manage every sort of light in the operating room, including the ambient light, UV light, OT light, and RGB light.",
        imageDescriptionList: [
          "The specified screen will be shown when the Light Button is pressed.",
          "Through this screen, the patient bed lights can be turned on and off.",
          "The brightness of the lights can be adjusted using the patient bed light brightness control.",
          "When the UV button is pressed, the timer and UV light are both turned on or off.",
          "RGB Light controls the intensity of the green, blue, and red colors in RGB lights and can be used to turn them on and off",
        ],
      },
      {
        image: controlPanel4,
        imageTitle: "Gas Sensors Screen",
        imageDescription:
          "The readings for all the gases will be presented on the gas sensor screen, allowing us to gauge the OT's gas concentration and regulate the gases there in an emergency. Additionally, it will display both critical and regular states (high, low, and normal).",
        imageDescriptionList: [
          "The given screen will appear when the Gas Sensors Button is pressed.",
          "The screen showed the names of the gas sensors, their readings, and whether the saturation of the gas was normal, high, or low. We can control the number of gases by monitoring their condition with gas sensors.",
          "Graphs Button show us the graphs of the gases",
        ],
      },
    ],
  },

  {
    id: "9",
    image: socketImage,
    title: "Electric & Gas Socket",
    key: "Electric-&-Gas-Socket",
    products: [
      {
        title: "Electrical sockets",
        description: [
          "Sockets are available for DIN and British standards as well as universal sockets. Universal sockets accept different light plugs.",
        ],
        imagesData: [
          {
            image: ukSocketImage,
            title: "UK Socket",
          },
          {
            image: dinSocketImage,
            title: "DIN Socket",
          },
          {
            image: universalSocketImage,
            title: "Universal",
          },
        ],
      },
      {
        title: "Gas sockets mounted on the wall",
        description: [
          "Herzmann offers, as basic equipment, electrical sockets which are available in three variants namely DIN British Standard, or as a universal socket. There is also a wall-integrated medical gas cabinet available with up to six connections, also configured as a DIN or BS element. The Herzmann Technik Team is happy to support you as an advisory unit.",
        ],
        imagesData: [
          {
            image: dinStandardOutletImage,
            title: "DIN Standard Outlet",
          },
          {
            image: britishStandardOutletImage,
            title: "British Standard Outlet",
          },
        ],
      },
    ],
  },

  {
    id: "10",
    title: "Door",
    key: "Door",
    image: doorImage,
    products: [
      {
        title: "Sliding Doors",
        description: [
          "Sliding doors are widely used in this application as they save space and are also safe. Since there is no swing movement, there is no risk of accidents. The standard size is used in the construction. In special cases and at an additional cost, special sizes are also available. Normally, operating room doors are equipped with a window as standard. Optionally, the window can be removed.",
          "Sliding doors can be motorized and additionally secured with a battery. These can be equipped with grip, hand or foot sensors for operation. The function of fully opening the door for a bed or partially opening the door for a single person is available.",
          "Manual sliding doors are also available as an economical alternative.",
        ],
        imagesData: [
          {
            image: slidingDoorImage,
            title: "Sliding Door",
          },
          {
            image: slidingDoorAutoImage,
            title: "Sliding Door Auto",
          },
          {
            image: slidingDoorManualImage,
            title: "Sliding Door Manual",
          },
        ],
      },
      {
        title: "Swing Doors",
        description: [
          "Access to the rear or side rooms can optionally be via swing doors. Please consult our design team to discuss     possibilities. These are available in single or double sheets. With or without a window.",
        ],
        imagesData: [
          {
            image: swingDoorImage,
            title: "Swing Door 1",
          },
          {
            image: swingDoorDoubleLeafImage,
            title: "Swing Door 2 Double Leaf",
          },
          {
            image: swingDoorDoubleLeafImage1,
            title: "Swing Door 2 Double Leaf",
          },
        ],
      },
    ],
  },
  {
    id: "11",
    title: "Operation Theater Lights",
    key: "Operation-Theater-Lights",
    image: lightsImage,
    products: [
      {
        title: "OT Lights",
        description: [
          "Herzmann offers a wide range of OT lights. It is advisable to discuss the design requirements early in the design phase. This includes elevation data and a dome or two. Any luminaire with single or double dome. With or without a camera and built-in battery backup. Lights with cameras have additional devices such as screens, audiovisual equipment, etc. All variants and options are on our program.",
        ],
        imagesData: [
          {
            image: otLight1Image,
            title: "OT Light 1",
          },
          {
            image: otLight2Image,
            title: "OT Light 2",
          },
          {
            image: otLight3Image,
            title: "OT Light 3",
          },
        ],
      },
    ],
  },
];

export default ProductsData;
